"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.SCREEN_SIZES = void 0;
var SCREEN_SIZES = {
  mobileMedium: 375,
  mobileLarge: 425,
  tabletPortrait: 576,
  tabletLandscape: 768,
  desktop: 992,
  largeDesktop: 1200,
  mediumLargeDesktop: 1300,
  extraLargeDesktop: 1440,
  monitor: 1800
}; // eslint-disable-next-line

exports.SCREEN_SIZES = SCREEN_SIZES;
var sizes = {
  mobileMedium: "(min-width: ".concat(SCREEN_SIZES.mobileMedium, "px)"),
  mobileLarge: "(min-width: ".concat(SCREEN_SIZES.mobileLarge, "px)"),
  tabletPortrait: "(min-width: ".concat(SCREEN_SIZES.tabletPortrait, "px)"),
  tabletLandscape: "(min-width: ".concat(SCREEN_SIZES.tabletLandscape, "px)"),
  desktop: "(min-width: ".concat(SCREEN_SIZES.desktop, "px)"),
  largeDesktop: "(min-width: ".concat(SCREEN_SIZES.largeDesktop, "px)"),
  mediumLargeDesktop: "(min-width: ".concat(SCREEN_SIZES.mediumLargeDesktop, "px)"),
  extraLargeDesktop: "(min-width: ".concat(SCREEN_SIZES.extraLargeDesktop, "px)"),
  monitor: "(min-width: ".concat(SCREEN_SIZES.monitor, "px)")
};
exports.sizes = sizes;